module.exports = __webpack_public_path__ + "img/banner.d84f7dd6.png";